import { createContext } from 'react';
import { useViewportPageIndex } from './hooks';

export type ViewportPageIndexContextType = ReturnType<typeof useViewportPageIndex>;

export const ViewportPageIndexContext = createContext<ViewportPageIndexContextType | null>(null);
